import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";

const ExpandedBatchHistory = ({item}) => {
    return (
        <ExpandedComponent items={[


            {title: 'محصول', value: item.product, class: 'xs:hidden'},
            {title: 'چاپ شده', value: item.printedCounter, class: '3xs:hidden'},
            {title: '  تحویل به انبار', value: item.registredCounter, class: 'sm:hidden'},
            {title: 'ابطال', value: item.cancleCounter, class: 'sm:hidden'},
            {title: ' در حال بررسی', value: item.quarantineCounter, class: 'md:hidden'},

            {title: 'امحا', value: item.destroyedCounter, class: '2md:hidden'},
            {title: 'بازسازی شده', value: item.totalReconstructCounter, class: '2md:hidden'},
            // {title: 'تعداد در پالت', value: item.numberPerPallet, class: 'lg:hidden'},
            {title: 'کنترل کیفی', value: item.qualityControlAdmin, class: 'lg:hidden'},
            {title: 'تاریخ ثبت', value: item.created, class: 'lg:hidden'},
            {title: 'زمان پایان', value: item.stopDate, class: 'lg:hidden'},

        ]}/>
    );
};

export default ExpandedBatchHistory;